<svelte:options accessors/>
<script>
    import {onMount, createEventDispatcher} from 'svelte';
    import NauiExplorer from "../../../naui/pages/NauiExplorer.svelte";
    import NauiButton from "../../../naui/atoms/NauiButton.svelte";
    import NauiTag from "../../../naui/atoms/NauiTag.svelte";
    import NauiSlideOver from "../../../naui/layout/NauiSlideOver.svelte";
    import NauiTable from "../../../naui/components/NauiTable.svelte";

    export let data;
    export let filters;
    export let columns;

    let open = false;
    let dispatch = createEventDispatcher();

    $: enabled = data ? data.filter(d => d.items > 0) : [];
    $: totalM3 = enabled.reduce((total, item) => total + ((item.m3 * 1000) * item.items) / 1000, 0);

    $: labelTotalm3 = `Total m³ | ${+totalM3.toFixed(3)}`;
    let filtered = null;

    let summaryColumns = [
        {
            slug: 'name',
            label: 'Item',
            type: 'text',
            order: false
        },
        {
            slug: 'items',
            label: 'Cantidad',
            type: 'text',
            order: false
        },
        {
            slug: 'm3',
            label: 'm³ / item',
            type: 'text',
            order: false
        },

        {
            slug: 'bubbles',
            label: 'Metros burbuja',
            type: 'text',
            order: false
        },
        {
            slug: 'cardboard',
            label: 'Metros cartón',
            type: 'text',
            order: false
        },
        {
            slug: 'actions',
            label: '',
            type: 'actions',
            order: false
        }
    ];

    function add() {
        open = true;
    }

    onMount(() => {
        filtered = data;
    });

    function showImages() {
    }

    function filterData(ev) {
        const category = ev.detail.filters.category;
        const term = ev.detail.term;
        filtered = category ? data.filter(item => item.categories.indexOf(category) > -1) : (data || []);
        if (term) {
            filtered = filtered.filter(item => item.name.toLowerCase().includes(term.toLowerCase()));
        }
    }

    function changeData(ev) {
        const item = ev.detail.item;
        item.items = ev.detail.data;
        item.m3_total = ((item.m3 * 1000) * item.items) / 1000;
        data = data;
    }

    function removeItem(ev) {
        ev.detail.data = 0;
        changeData(ev);
        filtered = data;
    }
</script>

<div class="py-15">
    {#if filtered != null}
    <NauiExplorer bind:data={filtered} {columns} {filters}
                  searchLabel="Buscar por nombre del articulo"
                  paginate={false} on:filter={filterData} on:next on:action={(ev) => changeData(ev)}>
        <div slot="actions">
            <div class="box-l sx-15 ml-15">
                <div class="grid grid-3 gap-ii">
                    <NauiButton on:click={add} caption="AGREGAR A LA COTIZACIÓN" mode="stroked" icon="plus"/>
                    <NauiButton on:click={showImages} caption="VER IMAGES DEL SERVICIO" icon="image" mode="accent"/>
                    <NauiTag label={labelTotalm3}/>
                </div>
            </div>
        </div>
    </NauiExplorer>
    {/if}
    <NauiSlideOver title="Agregar a la cotización" maxWidth="500px" bind:open={open}>
        <NauiTable columns={summaryColumns} data={enabled} on:action={(ev) => removeItem(ev)}/>
        <div class="box-c py-15">
            <h2 class="accent">{labelTotalm3}</h2>
        </div>
        <NauiButton on:click={dispatch('save', {data: enabled})}
                    color="accent"
                    mode="solid"
                    caption="AGREGAR A LA COTIZACIÓN"/>
    </NauiSlideOver>
    <div class="p-1">
        <NauiButton on:click={() => open = true} caption="AGREGAR A LA COTIZACIÓN" mode="stroked" icon="plus"/>
    </div>
</div>